import { Application } from '@hotwired/stimulus';
import EditableController from './editable_controller';
import BookingController from './booking_controller';
import SelectController from './select_controller';
import CleanTablesController from './clean_tables_controller';
import WaitingqueueNotificationController from './waitingqueue_notification_controller'
import ToggleCheckboxController from './toggle_checkbox_controller';
import MobileNavController from './mobile_nav_controller';
import ExpensesController from "./expenses_controller"
import BillingAddressController from "./billing_address_controller"
import CancellationFeeController from './cancellation_fee_controller';
import CheckboxFilterController from './checkbox_filter_controller';
import DisableOnSubmitController from './disable_on_submit_controller';
import ScrollToTopController from './scroll_to_top_controller';
import ClipboardController from './clipboard_controller';

const application = Application.start();
application.debug = true
// Import and register your controllers here
application.register('billing-address', BillingAddressController);
application.register('booking', BookingController);
application.register('select', SelectController);
application.register('editable', EditableController);
application.register('clean-tables', CleanTablesController);
application.register('mobile-nav', MobileNavController);
application.register('toggle-checkbox', ToggleCheckboxController);
application.register('waitingqueue-notification', WaitingqueueNotificationController);
application.register("expenses", ExpensesController)
application.register('cancellation-fee', CancellationFeeController);
application.register('checkbox-filter', CheckboxFilterController);
application.register('disable-on-submit', DisableOnSubmitController);
application.register('clipboard', ClipboardController);
application.register('scroll-to-top', ScrollToTopController);

console.log("initializing stimulus controllers");

export { application };
